<template>
  <button
    type="button"
    data-test-id="sidebar-sound-btn"
    class="sound-icon d-flex align-items-center"
    :aria-label="soundToggleAriaLabel"
    :aria-pressed="isMuted"
    @click="toggleNotfSound"
  >
    <i
      :class="isMuted ? 'ri-volume-mute-fill' : 'ri-volume-up-fill'"
      aria-hidden="true"
    />
    <div aria-hidden="true">
      <audio id="notifications-audio">
        <source src="@/assets/sounds/pristine-609.mp3" type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>
    </div>
  </button>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: "SoundBtn",
  props: ["user"],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      isMuted: "authentication/isMuted"
    }),
    soundToggleAriaLabel() {
      return this.isMuted
        ? this.$t("common.a11y_unmute_notification_sounds")
        : this.$t("common.a11y_mute_notification_sounds")
    }
  },
  watch: {
    isMuted: function (from, to) {
      if (to) {
        this.$helpers.playNotificationSound()
      } else {
        this.$helpers.stopNotificationSound()
      }
    }
  },
  methods: {
    toggleNotfSound() {
      this.$store.dispatch("layout/toggleNotificationSounds", this.user.role.id)
    }
  }
}
</script>
